module.exports = __webpack_public_path__ + "img/3.e708ba61.jpg";